import React from "react";

import ReactSliderWrapper from "./ReactSliderWrapper";

export default function TransactionAmount() {
    return <ReactSliderWrapper />;
}
